import { ApplicationConfig, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app.routes';
import { CookieService } from 'ngx-cookie-service';
import { ConstantService } from './Shared/Services/constant-service';
import { EncryptDataService } from './Shared/Services/encrypt-data.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { SharedHttpClientService } from './Shared/Services/shared-http-client.service';
import { provideHttpClient } from '@angular/common/http';
import { UserService } from './Shared/Services/user.service';
import { AuthguardGuard } from './Authentification/authguard.guard';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { AuditTrailService } from './Shared/Component/audit-trail/audit-trail.service';
import { EventTreeService } from './Shared/Component/event-tree/event-tree.service';
import { JsonViewerService } from './Shared/Component/json-viewer/json-viewer.service';
import { FinraExceptionService } from './Pages/cat-dashboard/finra-exception/finra-exception.service';
import { EventConversionService } from './Shared/Component/event-conversion/event-conversion.service';
import { NewROEService } from './Shared/Component/new-roe-entry/new-roe-entry.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';
import { BrokerMappingService } from './Pages/ref-data-viewer/broker-mapping/broker-mapping.service';
import { CatAnalyticsService } from './Pages/cat-dashboard/cat/cat-analytics/cat-analytics.service';
import { CatalystCommentViewerService } from './Shared/Component/catalyst-comment-viewer/catalyst-comment-viewer.service';
Chart.register(ChartDataLabels);
import { CatReconService } from './Pages/cat-dashboard/cat-recon/cat-recon.service';
import { CatReconCommentViewerService } from './Shared/Component/cat-recon-comment-viewer/cat-recon-comment-viewer.service';
import { provideServiceWorker } from '@angular/service-worker';
import { providePrimeNG } from 'primeng/config';
import lara from '@primeuix/themes/lara';
import { ToastHistoryService } from './Shared/Services/toast-history-service';
import { AuthServiceService } from './Authentification/auth-service.service';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(),
    provideAnimations(),
    provideCharts(withDefaultRegisterables()),
   //  UrlsService,
    AuthServiceService,
    CookieService, 
    UserService,
  //   GridService,
  //   DataService,
     EventTreeService,
    EncryptDataService,
    ConstantService,
  //   EmitterService,
     MessageService,
     AuditTrailService,
  //   CAISAuditTrailService,
     JsonViewerService,
  //   CaisServiceService,
  //   CatReconService,
     NewROEService,
  FinraExceptionService,
  EventConversionService,
  BrokerMappingService,
  CatAnalyticsService,
  CatalystCommentViewerService,
  CatReconService,
  CatReconCommentViewerService,
  ToastHistoryService,
   { provide: APP_BASE_HREF, useValue: '/Rsms/' },
    SharedHttpClientService,
    ConfirmationService,
    DatePipe,
    AuthguardGuard,
    SortPipe,
      providePrimeNG({
         theme: {
            preset: lara,
            options: {
            darkModeSelector: '.my-app-dark'
        }
         }
      }),
      provideServiceWorker('ngsw-worker.js', {
         enabled: true,
         registrationStrategy: 'registerWhenStable:30000'
      })
   ]
};

